import api from "../api";

// export const getAllCoursesByStaff = async () => {
//     try {
//       const response = await api.get('/course/assignedCourses');
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching courses:', error);
//       throw error;
//     }
//   };
 export const getMyPoliciesByStaff = async ({ page = 1, search = '' }) => {
  try {
    const response = await api.get('/policy/staff', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};
   export const getAllCoursesByStaff = async ({ page = 1, search = '' }) => {
  try {
    const response = await api.get('/course/assignedCourses', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};

  export const getCoursesById = async (id) => {
    try {
      const response = await api.get(`/course/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

    export const completeVideo = async (payload) => {
    try {
      const response = await api.post(`/course/completeVideo`,payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

   export const SubmitQuiz = async (payload) => {
    try {
      const response = await api.post(`/course/attemptQuiz`,payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

   export const getMyDashboardData = async () => {
    try {
      const response = await api.get(`/staff/dashboard`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

   export const getAllUserForChatForStaff = async (value) => {
    try {
      const response = await api.get(`/contacts/staff?search=${value}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

    export const getUserChat = async (payload) => {
    try {
      const response = await api.post(`/chat/chat`,payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

  export const generateCertificate = async (id) => {
    try {
      const response = await api.get(`/course/certificate/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };
    export const downloadCertificate = async (id) => {
    try {
      const response = await api.get(`/course/downloadCertificate/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };